import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { AmdocsUserService } from 'amdocs-auth-package';
import {AmdocsSwiperComponent} from 'amdocs-core-package';
import { AnimationOptions } from 'ngx-lottie';
import * as AmdocsContentConstants from '../../../content.constants';

@Component({
  selector: 'app-on-boarding',
  templateUrl: './on-boarding.component.html',
  styleUrls: ['./on-boarding.component.scss'],
})
export class OnBoardingComponent implements OnInit {

  public amdocsContentConstant: any = AmdocsContentConstants?.default;
  currentItemValue = 0;
  constructor(private userService: AmdocsUserService,private cdr: ChangeDetectorRef) { }

 @ViewChild('amdocsSwiperComponent') amdocsSwiperComponent: AmdocsSwiperComponent;
 

  @Output() skipCallback: EventEmitter<any> = new EventEmitter();

  public options1: AnimationOptions = {
    path: `/assets/gifs/01.json`,
    autoplay: true,
    loop: true,
    
  };

  public options2: AnimationOptions = {
    path: `/assets/gifs/02.json`,
  };

  public options3: AnimationOptions = {
    path: `/assets/gifs/03.json`,
  };

  public options4: AnimationOptions = {
    path: `/assets/gifs/04.json`,
  };

  public options5: AnimationOptions = {
    path: `/assets/gifs/05.json`,
  };
  public userName;
  public showOnboarding = false;

  ngOnInit(): void {
    this.userName = this.userService?.user?.userProfile?.name.split(' ')[0];
    this.showOnboarding = true;
  }



  onAnimationCreated(animationItem: any): void {
    console.log('Lottie animation created:', animationItem);
  }
  

  skip(): void {
    this.skipCallback.emit();
  }


  next(): void{
    this.amdocsSwiperComponent?.next();
    this.currentItemValue = this.amdocsSwiperComponent?.currentItem;
  }

  getSlideTopStyle(): string {
    if (document.getElementsByClassName('lotti-wrapper')) {
      const heightOffset = parseFloat((document.getElementsByClassName('lotti-wrapper')[0] as any).offsetHeight) + 57;
      if ( heightOffset > 57) {

      return `height: calc(100% - ${heightOffset}px`;
      }
    }
  }
}
